import React, { useState } from 'react';

const DISPOSAL_ROOM = 'Entsorgung';

const RoomSelector = ({ rooms, currentRoom, onRoomChange, onAddRoom }) => {
  const [newRoom, setNewRoom] = useState('');

  const handleAddRoom = () => {
    if (newRoom && !rooms.includes(newRoom) && newRoom !== DISPOSAL_ROOM) {
      onAddRoom(newRoom);
      setNewRoom('');
    }
  };
  
  // Trenne reguläre Räume und Entsorgung
  const regularRooms = rooms.filter(r => r !== DISPOSAL_ROOM);
  const disposalRoom = rooms.find(r => r === DISPOSAL_ROOM);

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold mb-2">Räume</h2>
      
      {/* Regular Rooms Grid */}
      <div className="grid grid-cols-1 gap-2">
        {regularRooms.map((room) => (
          <button
            key={room}
            onClick={() => onRoomChange(room)}
            className={`
              p-3 rounded-lg text-left transition-all duration-200
              ${currentRoom === room 
                ? 'bg-primary text-white' 
                : 'bg-white hover:bg-gray-50 text-gray-700 border border-gray-200'
              }
            `}
          >
            {room}
          </button>
        ))}
      </div>
      
      {/* Entsorgung Section (separated) */}
      {disposalRoom && (
        <div className="mt-4 pt-4 border-t-2 border-orange-200">
          <h3 className="text-sm font-semibold text-orange-700 mb-2">Entsorgung</h3>
          <button
            onClick={() => onRoomChange(disposalRoom)}
            className={`
              w-full p-3 rounded-lg text-left transition-all duration-200
              ${currentRoom === disposalRoom 
                ? 'bg-orange-600 text-white' 
                : 'bg-orange-50 hover:bg-orange-100 text-orange-700 border border-orange-200'
              }
            `}
          >
            {disposalRoom}
          </button>
        </div>
      )}

      {/* Add New Room */}
      <div className="mt-4 flex">
        <input
          type="text"
          value={newRoom}
          onChange={(e) => setNewRoom(e.target.value)}
          placeholder="Neuer Raum"
          className="flex-grow p-2 border border-gray-300 rounded-l-lg focus:ring-2 focus:ring-primary focus:border-transparent"
        />
        <button
          onClick={handleAddRoom}
          className="bg-green-500 text-white px-4 rounded-r-lg hover:bg-green-600 transition-colors"
        >
          +
        </button>
      </div>

      {/* Summary */}
      <div className="mt-6 pt-4 border-t border-gray-200">
        <div className="flex justify-between text-sm text-gray-600">
          <span>Räume:</span>
          <span className="font-medium">{regularRooms.length}</span>
        </div>
      </div>
    </div>
  );
};

export default RoomSelector;